var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.8504 69.53C52.6704 69.82 52.3504 70 52.0004 70H28.0004C27.6504 70 27.3304 69.82 27.1504 69.53C26.9704 69.23 26.9504 68.86 27.1104 68.55L30.3904 62H49.6204L52.8904 68.55C53.0504 68.86 53.0304 69.23 52.8504 69.53Z",
    fill: "#CFBCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 10C33.93 10 29 14.93 29 21C29 27.07 33.93 32 40 32C46.07 32 51 27.07 51 21C51 14.93 46.07 10 40 10ZM45.71 18.71L38.71 25.71C38.51 25.91 38.26 26 38 26C37.74 26 37.49 25.9 37.29 25.71L34.29 22.71C33.9 22.32 33.9 21.69 34.29 21.3C34.68 20.91 35.31 20.91 35.7 21.3L37.99 23.59L44.28 17.3C44.67 16.91 45.3 16.91 45.69 17.3C46.08 17.69 46.08 18.32 45.69 18.71H45.71Z",
    fill: "#CFBCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.97 40C60.2 39.09 61 37.64 61 36C61 33.24 58.76 31 56 31H50C49.45 31 49 31.45 49 32V48C49 48.55 49.45 49 50 49H56C58.76 49 61 46.76 61 44C61 42.36 60.19 40.91 58.97 40ZM51 33H56C57.65 33 59 34.35 59 36C59 37.65 57.65 39 56 39H51V33ZM56 47H51V41H56C57.65 41 59 42.35 59 44C59 45.65 57.65 47 56 47Z",
    fill: "#7551D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9401 47.65L26.9401 31.65C26.7901 31.26 26.4201 31 26.0001 31C25.5801 31 25.2101 31.26 25.0601 31.65L19.0601 47.65C18.8701 48.17 19.1301 48.74 19.6501 48.94C20.1701 49.13 20.7401 48.87 20.9401 48.36L22.9501 43.01H29.0601L31.0701 48.36C31.2201 48.76 31.6001 49.01 32.0101 49.01C32.1301 49.01 32.2501 48.99 32.3601 48.95C32.8801 48.76 33.1401 48.18 32.9501 47.66L32.9401 47.65ZM23.7001 41L26.0101 34.85L28.3201 41H23.7101H23.7001Z",
    fill: "#7551D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65 16H52C52.27 16.64 52.49 17.31 52.65 18H65C66.65 18 68 19.35 68 21V52H41V33.96C40.67 33.99 40.34 34 40 34C39.66 34 39.33 33.99 39 33.96V52H12V21C12 19.35 13.35 18 15 18H27.35C27.51 17.31 27.73 16.64 28 16H15C12.24 16 10 18.24 10 21V55C10 57.76 12.24 60 15 60H65C67.76 60 70 57.76 70 55V21C70 18.24 67.76 16 65 16Z",
    fill: "#7551D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbCampaign);
export default __webpack_public_path__ + "static/media/ab-campaign.c40f22f6c6f282b160dc7bfef2760672.svg";
export { ForwardRef as ReactComponent };